<div class="container">
  <app-simple-file-select label="Plik ze zleceniami"
                          [formControl]="innerFileControl">
  </app-simple-file-select>
</div>
